import React, {useState} from 'react';
import './AdminManagement.js';
import { 
    DataGridPremium,
	LicenseInfo,
	GridColDef,
	GridRowModel
} from '@mui/x-data-grid-premium';
import NoRowsDataGridComponent from '../../../components/NoRowsDataGridComponent/NoRowsDataGridComponent.js';
import config from '../../../config.js';

LicenseInfo.setLicenseKey(
    config.DATAGRID_LICENSE,
);

const columns = [
    { field: 'DINTEST_FATT', headerClassName: 'header-cell soggettoFatturazioneDesc', headerName: "Soggetto Fatturazione", type: 'text', width: 300, editable: false},
    { field: 'DCLIENTE', headerClassName: 'header-cell clienteDesc', headerName: "Cliente", type: 'text', width: 270, editable: false},
    { field: 'DAGENZIA', headerClassName: 'header-cell agenziaDesc', headerName: "Agenzia", type: 'text', width: 270, editable: false},
    { field: 'KPROPOSTA', headerClassName: 'header-cell kProposta', headerName: "Id", type: 'text', width: 75, editable: false, align: 'center', headerAlign: 'center', disableColumnMenu: true},
    { field: 'DPROPOSTA', headerClassName: 'header-cell propostaDesc', headerName: "Proposta", type: 'text', width: 270, editable: false},
    { field: 'DATA_FATTURAZIONE', headerClassName: 'header-cell dataFattura', headerName: "Data Fattura", type: 'text', width: 100, editable: false,/*  valueFormatter: (params) => getFormatDate(params.value) */},
    { field: 'IMPORTO', headerClassName: 'header-cell importoFattura', headerName: "Importo Fattura", description: 'Proposte Contrattualizzate, Contrattualizzate in Modifica e Chiuse', type: 'text', width: 130, editable: false, align: 'right', headerAlign: 'right', /* valueFormatter: (params) => {return (params.value || params.value === 0) ? formatNumbersIt(params.value) + ' €' : '0 €'} */},
    { field: 'NOTE', headerClassName: 'header-cell note', headerName: "Note", type: 'text', width: 300, editable: false},
    { field: 'FLAG_FATTURATO', headerClassName: 'header-cell flagFatturato', headerName: "Fatturato", type: 'text', width: 75, editable: false, align: 'center', headerAlign: 'center',/*  renderCell: (params:any) => ActiveCell(params), */},
];

function AdminManagement() {

    const [rows, setRows] = useState([])

    return (
        <div className='component-container home'>
			<div className='component-card'>
                <DataGridPremium
                    className='dataGrid'
                    slots={{
                        noRowsOverlay: NoRowsDataGridComponent,
                    }}
                    initialState={{ pinnedColumns: { right: ['FLAG_CONFERMA_ATT', 'FLAG_FATTURATO'] } }}
                    rows={rows}
                    columns={columns}
                    rowHeight={30}
                    hideFooter={true}
                    isCellEditable={(params) => params.id!==0}
                    disableColumnMenu={false}
                    disableColumnReorder={true}
                    disableAggregation={true}
                    disableColumnFilter={true}
                    disableRowGrouping={true}
                    getRowClassName={(params) => params.row.KSTATO === '06' ? 'red-row' : !params.id ? 'non-editable-row' : ''}
                    //pinnedRows={{bottom: [], top: [rows.length > 0 ? rows.find((row:any) => row.id===0) : {id:0}]}}
                />
            </div>
        </div>
    )
}

export default AdminManagement